// api.js
import axios from 'axios';

const apiBase = `${process.env.REACT_APP_API_DOMAIN || ''}${process.env.REACT_APP_API_VERSION || ''}`;

const API = axios.create({
    baseURL: apiBase,
    withCredentials: false,
});

// Single in-flight token fetch gate — prevents duplicate /auth/token requests
let tokenPromise = null;

async function getAccessToken() {
    const response = await fetch(`${apiBase}/auth/token`, {
        credentials: 'include',
    });
    if (!response.ok) return null;
    const data = await response.json();
    return data.access_token ?? null;
}

// List of endpoints that do NOT require auth
const publicEndpoints = ['/CreateUser'];

API.interceptors.request.use(async (config) => {
    if (
        publicEndpoints.some(
            (ep) =>
                config.url &&
                (config.url === ep || config.url.startsWith(ep + '/') || config.url.startsWith(ep + '?'))
        )
    ) {
        return config;
    }

    if (!tokenPromise) {
        tokenPromise = getAccessToken().finally(() => {
            tokenPromise = null;
        });
    }
    const token = await tokenPromise;
    if (token) {
        config.headers = config.headers || {};
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
});

// Retry once on 401 with fresh token
API.interceptors.response.use(
    (res) => res,
    async (error) => {
        const { config, response } = error;
        if (!response || !config) throw error;
        if (response.status !== 401 || config._retry) throw error;
        if (publicEndpoints.some((ep) => config.url && (config.url === ep || config.url.startsWith(ep + '/') || config.url.startsWith(ep + '?')))) throw error;

        tokenPromise = getAccessToken().finally(() => {
            tokenPromise = null;
        });
        const newToken = await tokenPromise;

        config._retry = true;
        config.headers = config.headers || {};
        config.headers['Authorization'] = `Bearer ${newToken}`;
        return API.request(config);
    }
);

export default API;
